import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { MxBaseComponent } from 'src/app/core/base/mx.base-component';

@Component({ standalone: false,
  selector: 'mx-file-upload',
  templateUrl: './mx.file-upload.component.html',
  styleUrls: ['./mx.file-upload.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: MxFileUploadComponent,
      multi: true,
    },
  ],
})
export class MxFileUploadComponent
  extends MxBaseComponent
  implements OnInit, ControlValueAccessor
{
  onChange: Function;
  file: File | null = null;

  @ViewChild('fileChooser')
  public fileChooser: ElementRef;

  @HostListener('change', ['$event.target.files']) emitFiles(event: FileList) {
    const file = event && event.item(0);
    this.onChange(file);
    this.file = file;
  }

  // @HostListener('ngModelChange', ['$event']) onModelChange(value: any) {
  //   if (!value) {
  //     console.log("reset?")
  //     // empty: probably reset, or just erased
  //     this.host.nativeElement.value = '';
  //     this.file = null;
  //   }
  // }

  constructor(private host: ElementRef<HTMLInputElement>) {
    super();
  }

  ngOnInit() {}

  writeValue(value: null) {
    // clear file input
    if (this.fileChooser) {
      this.fileChooser.nativeElement.value = '';
    }
    this.host.nativeElement.value = '';
    this.file = null;
  }

  registerOnChange(fn: Function) {
    this.onChange = fn;
  }

  registerOnTouched(fn: Function) {}
}
